import React, { useEffect, useState } from 'react';
import { SettingsStyles } from './Settings.styles';
import { ReactComponent as Arrowforward } from 'assert/images/Common/arrowForward.svg';
import { Button, CloseIcon, RadioButton } from 'components';
import { PostArrowBack } from 'pages/home/Home.style';
import { useTranslation } from 'react-i18next';
import { swipeModalWidth } from 'utils/helper';
import useWindowDimensions from 'components/Dimention';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import {
  handleGetManageMention,
  handleUpdateManageMention,
} from 'redux/features/SettingsSlice';

export default function PrivacySetting() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { width } = useWindowDimensions();
  const isSmallScreen = width <= swipeModalWidth;

  const [mention, setMention] = useState(0);
  const [loading, setLoading] = useState(true);
  const [openIndex, setOpenIndex] = useState(null);
  const [openAdvanceMention, setOpenAdvanceMention] = useState(false);

  const mentionOptions = [
    {
      label: t('Settings.Everyone'),
      value: 0,
      helperText: t('Settings.AnyoneMention'),
    },
    {
      label: t('Settings.PeopleWhoFollowYou'),
      value: 1,
      helperText: t('Settings.OnlyUserWhoMention'),
    },
    {
      label: t('Settings.NoOne'),
      value: 2,
      helperText: t('Settings.NoMention'),
    },
  ];
  const mentionOptions2 = [
    {
      label: t('Settings.PeopleYouFollow'),
      value: 3,
      helperText: t('Settings.OnlyUser'),
    },
    {
      label: t('Settings.PeopleBothFollow'),
      value: 4,
      helperText: t('Settings.BothUser'),
    },
    {
      label: t('Settings.EitherFollow'),
      value: 5,
      helperText: t('Settings.UserMention'),
    },
  ];

  useEffect(() => {
    const advanceManageOptions = [3, 4, 5];
    dispatch(handleGetManageMention())
      .then((res) => {
        if (advanceManageOptions?.includes(res?.data?.isMention)) {
          setOpenAdvanceMention(true);
        }
        setMention(res?.data?.isMention);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  }, []);

  const handleSaveMention = (data) => {
    setLoading(true);
    const payload = {
      isMention: data,
    };
    dispatch(handleUpdateManageMention(payload))
      .then(() => {
        setLoading(false);
        setMention(data);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  return (
    <SettingsStyles>
      <div className="setting-info-container">
        {openIndex === null && (
          <>
            <div className="setting-title">
              {isSmallScreen && (
                <CloseIcon
                  customStyle="back-icon"
                  iconType="back"
                  onClick={() => navigate('/settings')}
                />
              )}
              {t('Settings.Privacy')}
            </div>
            <div
              className="accept-request-label privacy-item"
              onClick={() => setOpenIndex(0)}
            >
              <div>
                <div className="setting-help-title">
                  {t('Settings.ManageMention')}
                </div>
                <div className="accept-request-helper">
                  {t('Settings.WhoCanMentionYou')}
                </div>
              </div>
              <Arrowforward className="right-arrow" />
            </div>
          </>
        )}
        {openIndex === 0 && (
          <div>
            <div className="setting-back">
              <PostArrowBack className="post-back">
                <CloseIcon
                  iconType={'back'}
                  onClick={() => setOpenIndex(null)}
                />
                <div>{t('Settings.ManageMention')}</div>
              </PostArrowBack>
            </div>
            <div className="mention-actions">
              <RadioButton
                label={t('Settings.WhoCanMentionYou')}
                options={mentionOptions}
                value={mention}
                onChange={(data) => handleSaveMention(data.target.value)}
                disabled={loading}
              />
            </div>
            <Button
              className="mention-advance-settings"
              variant="text"
              label={'Advance Settings'}
              onClick={() => {
                setOpenAdvanceMention(!openAdvanceMention);
              }}
            />
            {openAdvanceMention && (
              <div className="mention-actions">
                <RadioButton
                  options={mentionOptions2}
                  value={mention}
                  onChange={(data) => handleSaveMention(data.target.value)}
                  disabled={loading}
                />
              </div>
            )}
          </div>
        )}
      </div>
    </SettingsStyles>
  );
}
